import React from "react";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Form } from 'react-redux-form';
// Domain
import * as authDomain from "user/authentication/Authentication";
// Actions \ Action Creators
import * as authenticationActions from "user/authentication/actions";
//-- Domain UI --------------------------------------------------------------------------------------
// Components
import { TextBox } from "common/ui/components/inputs/TextBox";
import { FormServerError } from "common/ui/components/forms/FormServerError";
//-- Helpers --------------------------------------------------------------------------------------
// Form helpers
import validator from 'validator';
import { bindActionCreators } from "redux";
const mapStateToProps = (state) => ({
    requestVerifyForm: state.authenticationForms.requestVerifyForm,
});
const mapDispatchToProps = (dispatch) => ({
    authenticationActions: bindActionCreators(authenticationActions, dispatch),
    dispatch: dispatch
});
class VerifyRequestForm extends React.Component {
    //---------------------------------------------------------------------
    handleSubmit(form) {
        // Initialise local variables
        const { authenticationActions } = this.props;
        // Create Dto
        let dto = { mobile: form.mobile };
        // Send authentication request
        authenticationActions.verifyRequest(dto);
    }
    //---------------------------------------------------------------------
    render() {
        let { requestVerifyForm } = this.props;
        return (React.createElement(Form, { model: authDomain.pathsRequestVerify.modelPath, onSubmit: (form) => this.handleSubmit(form) },
            React.createElement(TextBox, { model: authDomain.pathsRequestVerify.mobile, form: this.props.requestVerifyForm, labelText: "Mobile number", errors: { required: "Mobile number is required" }, placeHolderText: "Enter mobile number", validators: { validMobile: (val) => validator.isMobilePhone(val, 'en-ZA') } }),
            React.createElement(FormServerError, { form: requestVerifyForm.$form }),
            React.createElement("div", { className: "form-group" },
                React.createElement(Button, { type: "submit", bsStyle: "success", disabled: requestVerifyForm.$form.pending || !requestVerifyForm.$form.valid }, requestVerifyForm.$form.pending ? 'Sending OTP...' : 'Send OTP'))));
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(VerifyRequestForm);
